import {
  Box,
  styled,
} from '@mui/material';

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: '8px 20px',
  '& a.isActive': {
    fontWeight: 700,
  },
}));

export default StyledBox;
